import React from 'react';
import {Button, Col, ConfigProvider, Form, Input, Modal, QRCode, Row} from 'antd';
import Colors from "../../../styles/Colors";
import {BiCheck, BiX} from "react-icons/bi";
import locale from "antd/es/locale/es_ES";
import {UploadOutlined} from "@ant-design/icons";

interface IngredientModalProps {
    visible: boolean;
    app: string;
    ios: string;
    onClose: (value: boolean) => void;
}

const ConfiguracioAppModal: React.FC<IngredientModalProps> = ({visible, onClose, app, ios}) => {
    const [form] = Form.useForm();

    async function handleSubmit() {
        const formData = form.getFieldsValue();
        console.log("Form Data:", formData);
        console.log(JSON.stringify(formData));

        //onClose(true);
    };

    const handleCancel = () => {
        onClose(false);
    };

    return (
        <ConfigProvider locale={locale}>
            <Modal
                title="Instruccions per les Apps"
                open={visible}
                onCancel={handleCancel}
                footer={[]}
                width={1000}
                maskClosable={false} // no se cierra al hacer clic fuera
            >
                <h3><p>ANDROID:</p></h3>
                <hr/>
                <p>Pasos a seguir:</p>
                <p>1) Descarregar l'app de l'enllaç del QR o del botó (fent click a descarregar).</p>
                <p>2) Donar permisos al dispositiu si ho requereix per poder instal·lar de fora de la play store.</p>
                <p>3) Entrar a l'aplicatiu amb l'usuari i contrassenya facilitats al correu electrònic (els mateixos que a aquesta web).</p>
                <p></p>
                <div style={{ display: 'flex', gap: '40px', marginBottom: '20px' }}>
                    <div style={{ textAlign: 'center' }}>
                        <h6>ART i ESPORTS</h6>
                        <QRCode
                            errorLevel="H"
                            value={app}
                        />
                        <a
                            href={app}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button icon={<BiCheck />} style={{ marginTop: '10px' }}>
                                Enllaç
                            </Button>
                        </a>
                    </div>
                </div>

                <h3><p>IOS:</p></h3>
                <hr/>
                <p>Pasos a seguir:</p>
                <p>1) Descarregar l'app <a href={"https://apps.apple.com/us/app/testflight/id899247664"}
                                           target="_blank">TestFlight</a></p>
                <p>2) Accedeix a l'app de fitxar escanejant el QR o prement el botó facilitats a continuació.</p>
                <p>3) Des de l'aplicatiu de TestFlight ja pots instal·lar l'aplicatiu.</p>
                <p>4) Entrar a l'aplicatiu amb l'usuari i contrassenya facilitats al correu electrònic (els mateixos que a aquesta web).</p>
                <p></p>
                <div style={{ display: 'flex', gap: '40px' }}>
                    <div style={{ textAlign: 'center' }}>
                        <h6>ART i ESPORTS</h6>
                        <QRCode
                            errorLevel="H"
                            value={ios}
                        />
                        <a
                            href={ios}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button icon={<BiCheck />} style={{ marginTop: '10px' }}>
                                Enllaç
                            </Button>
                        </a>
                    </div>
                </div>
            </Modal>


        </ConfigProvider>
    );
};

export default ConfiguracioAppModal;
